import dayjs from 'dayjs';
import { MEDIA_LIMITS_MB } from './constants';

export const kindOfFile = (file) => {
  if (file?.type?.startsWith('image/')) return 'image';
  if (file?.type?.startsWith('video/')) return 'video';
  return 'file';
};

export const validateAttachment = (file) => {
  if (!file) return 'Выберите файл';
  if (!file.size) return 'Пустой файл';

  const kind = kindOfFile(file);
  const limit = MEDIA_LIMITS_MB[kind];
  if (file.size > limit * 1024 * 1024) return `Файл больше ${limit} МБ`;

  return '';
};

export const formatFileSize = (size) => {
  if (!Number.isFinite(size)) return '';
  if (size < 1024) return `${size} Б`;
  if (size < 1024 * 1024) return `${Math.round(size / 1024)} КБ`;
  return `${(size / (1024 * 1024)).toFixed(1)} МБ`;
};

export const formatChatDate = (value) => {
  if (!value) return '';
  const date = dayjs(value);
  if (!date.isValid()) return '';
  return date.format('DD.MM.YYYY');
};

export const formatChatTime = (value) => {
  if (!value) return '';
  const date = dayjs(value);
  if (!date.isValid()) return '';
  if (date.isSame(dayjs(), 'day')) return date.format('HH:mm');
  return date.format('DD.MM.YYYY HH:mm');
};

export const hasActiveFilters = (filters) =>
  Boolean(filters?.status || filters?.organizationId || filters?.unreadOnly || filters?.q || (filters?.assignee && filters?.assignee !== 'all'));

export const createIdempotencyKey = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const organizationLabel = (organization) => organization?.name || 'Без компании';
